import request from '@/utils/request';

export default {
  summary() {
    return request({ url: 'statistics/summaryTable' });
  }
};
